import { createApp } from 'vue'
import App from './App.vue'
import router from "./routes"
import services from "./services/api.service"
import helpers from "./helpers"
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App).use(router).use(ElementPlus);
app.config.globalProperties.$helpers = helpers;
app.config.globalProperties.$services = services;
app.mount("#app");